import BaseToast from "@emcd-shared/toasts";

const ToastWrapper = {
  install(app) {
    app.use(BaseToast);
    if (!app.config.globalProperties.$toast) {
      console.warn("🚨 BaseToast plugin is not installed!");
    }
    const toast = app.config.globalProperties.$toast;

    app.config.globalProperties.$error = (message, options = {}) => {
      const translatedTitle = app.config.globalProperties.$t
        ? app.config.globalProperties.$t("Toast | Error | defaultTitle")
        : "Error";
      toast({
        type: "error",
        description: message,
        title: options.title || translatedTitle,
        ...options,
      });
    };

    app.config.globalProperties.$success = (message, options = {}) => {
      const translatedTitle = app.config.globalProperties.$t
        ? app.config.globalProperties.$t("Toast | Success | defaultTitle")
        : "Success";
      toast({
        type: "success",
        description: message,
        title: options.title || translatedTitle,
        ...options,
      });
    };

    app.config.globalProperties.$warning = (message, options = {}) => {
      const translatedTitle = app.config.globalProperties.$t
        ? app.config.globalProperties.$t("Toast | Warning | defaultTitle")
        : "Warning";
      toast({
        type: "warning",
        description: message,
        title: options.title || translatedTitle,
        ...options,
      });
    };
  },
};

export default ToastWrapper;
